import {popupCreateUser, popupEditUser, popupCreateUpdateUser, popupResetPassword} from "../common/PopupForms";

export function tableWorkers(HelperTable) {

    const selectorTable = '#table_workers';
    const elTable = $(selectorTable)
    const canCreate = ESR.Helper.canCreate();
    const canEditOther = ESR.Helper.canEditOther();
    const canViewReports = ESR.Helper.userCan('view_reports')
    const canViewReportUser = ESR.Helper.userCan('view_report_worker')
    const currentUserID = ESR.user.id
    if (!elTable?.length) {
        return;
    }


    const columns = [
        {
            label: ESR.lang.user_name,
            data: null,
            defaultContent: '',
            orderable: true,
            render: (data, type, row) => {
                const isDisplay = type === 'display';
                const isSameUser = parseInt(row.id) === parseInt(currentUserID)

                if (isDisplay && (canViewReports || (canViewReportUser && isSameUser))) {
                    return `<a href="${ESR.Helper.getReportWorkerUrl({id: row.id})}">${row.name}</a>`
                }

                return row.name;
            }
        },
        {
            label: ESR.lang.role,
            data: 'role',
            orderable: true,
            visible: false,
            render: (data, type, row) => row.role.label
        },
        {
            label: ESR.lang.job_title,
            data: 'job_title',
            orderable: true,
            visible: true
        },
        {label: ESR.lang.email, data: 'email', orderable: false,  visible: false},
        {label: ESR.lang.phone_number, data: 'phone', orderable: true}
    ];

    if (ESR.Helper.userCan('edit_users')) {
        const columnDefinitions = [
            {label: ESR.lang.id, data: 'id', orderable: true, visible: false},
            {label: ESR.lang.login, data: 'login', orderable: false, visible: false},
            {label: ESR.lang.coef, data: 'coef', orderable: true, visible: false},
            {label: ESR.lang.terminated_on, data: 'dismised_date', orderable: true, visible: true}
        ];

        // Unshift 'ID' column at the beginning
        columns.unshift(columnDefinitions.shift());

        // Push the rest of the columns
        columns.push(...columnDefinitions);
    }


    const myTableHeader = HelperTable.createRowHeader(columns);
    elTable.append(myTableHeader)

    let toolbarButtons = [];

    if (canEditOther) {
        function callbackBtnAdd(e) {
            e.preventDefault();
            popupCreateUpdateUser();
        }

        function callbackBtnEdit(e) {
            e.preventDefault();

            const elRow = table.row('.selected');

            if (!elRow.node()) {
                // "No row selected."
                return;
            }

            popupCreateUpdateUser(elRow.data());
        }

        function callbackBtnRemove(e) {
            e.preventDefault();

            const elRow = table.row('.selected');
            if (!elRow.node()) return;   // "No row selected."
            const rowData = elRow.data();

            ESR.Popup.delete({
                title: rowData.name,
                html: `<p>Datele utilizatorului vor fi șterse definitiv, numele acestuia nu va fi în rapoartele generate.</p> <br> 
                        <small>O soluție mai bună e să schimbați rolul în <b>Concediat</b>.</small><br> 
                        <small>Apăsați buttonul <b>Închide</b>, apoi butonul <b>Editează</b> și modificați cîmpul <b>Rol și Access</b> în "Concediat".</small>`,
                action: 'esr_delete_user',
                id: rowData.id
            })
        }

        function callbackBtnResetPassword(e) {
            e.preventDefault();

            const elRow = table.row('.selected');
            if (!elRow.node()) return;   // "No row selected."
            const rowData = elRow.data();

            popupResetPassword(rowData.id, rowData.name)
        }

        toolbarButtons = [
            HelperTable.btnColvis(),
            HelperTable.btnDownloads(),
            // HelperTable.btnAdd(e => callbackBtnAdd(e)),
            HelperTable.btnAdd(e => callbackBtnAdd(e)),
            HelperTable.btnEdit(e => callbackBtnEdit(e)),
            HelperTable.createButton('Resetează Parola', 'btn btn-sm btn-neutral btn-reset-password btn-disabled', callbackBtnResetPassword),
            HelperTable.btnRemove(e => callbackBtnRemove(e)),
        ]
    }


    const table = new DataTable(selectorTable, {
        responsive: true,
        select: false,
        data: window.tableData,
        columns: columns,
        stateSave: true,
        order: [
            [1, 'asc']
        ],
        pageLength: 20,
        processing: false,
        serverSide: false,
        info: false,
        layout: {
            topStart: {
                buttons: toolbarButtons
            },
            topEnd: {
                search: {
                    text: '',
                    placeholder: ESR.lang.search
                }
            },
            bottom: 'paging',
            bottomStart: null,
            bottomEnd: null
        },
        language: {
            emptyTable: ESR.lang.emptyTable,
        },
        initComplete: function () {
            const api = this.api();
            const state = api.state.loaded()

            if (canEditOther) {
                const colRoleIndex = 2;
                const colRole = api.column(colRoleIndex)
                const colRoleStateValue = state?.columns[colRoleIndex]?.search?.search ?? ''

                const optionsRoles = Object.values(ESR.user_roles).map(function (value) {
                    return {value: value, label: value}
                })

                const elSelectRoles = ESR.View.select({
                    value: colRoleStateValue,
                    placeholder: 'Toate rolurile',
                    class: 'select select-bordered select-sm',
                    options: optionsRoles
                }).on('change', function () {
                    colRole.search($(this).val(), {exact: false}).draw();
                });

                $('.dt-layout-row:eq(0) >.dt-layout-end').prepend(elSelectRoles)


                const colIndexJob = 3;
                const colJob = api.column(colIndexJob)
                const colJobStateValue = state?.columns[colIndexJob].search.search ?? ''
                const optionsJobs = HelperTable.serializeTableDataJobOptions( window.tableData );
                const elSelectJob = ESR.View.select({
                    value: colJobStateValue,
                    placeholder: 'Funcție',
                    class: 'select select-bordered select-sm',
                    options: optionsJobs
                }).on('change', function () {
                    colJob.search($(this).val(), {exact: false}).draw();
                });

                $('.dt-layout-row:eq(0) >.dt-layout-end').prepend(elSelectRoles).prepend(elSelectJob)
            }
        },
    });


    if (canEditOther) {
        const btnRowCreate = table.buttons().container().find('.btn-row-create')
        const btnRowEdit = table.buttons().container().find('.btn-row-edit')
        const btnRowRemove = table.buttons().container().find('.btn-row-remove')
        const btnResetPassword = table.buttons().container().find('.btn-reset-password')
        $('body').on('click', (e) => {
            HelperTable.onSelectRow(e, table, btnRowEdit, btnRowRemove, btnResetPassword)
        });
    }


}